module.exports = __webpack_public_path__ + "fonts/Roboto-100-greek12.7663018.woff2";